<template>
	<q-modal v-model="videoPlayerModal" :content-css="contentCSS">
		<q-modal-layout>
			<div id="videoContainer">
				<div id="video-title" class="video-title q-title ellipsis absolute">{{ project.title }} | {{ language }}</div>
			</div>
			<q-btn v-if="posterMode" id="btn-set-video-poster" class="q-mt-md float-right poster-btn" label="Set Poster Image" dense color="simpleshow" @click="setPosterImage()"></q-btn>
			<q-btn v-if="downloadable" id="btn-download-video" class="q-mt-md float-right poster-btn" label="Download" dense color="simpleshow" @click="downloadVideo(videoFileName)"></q-btn>
		</q-modal-layout>
	</q-modal>
</template>

<script>
	// ####################################################################################################################
	// ####################################################################################################################
	// import Vue from 'vue'
	// import '../../../../js/vendor/videojs/videojs-resolution-switcher.min.js';
	import '../../../../vendor/videojs/videojs-resolution-switcher.min.js';
	// import '../../../js/vendor/videojs/videojs.hotkeys.min.js';
	import '../../../../vendor/videojs/videojs.hotkeys.min.js';

	window.videojs = require('video.js');

	export default {
		name: 'VideoPlayerModal',
		props2: ['showVideoPlayerModal', 'project', 'languageCode', 'language', 'posterMode', 'downloadable'],
		props: {
			showVideoPlayerModal: {
				type: Boolean,
				default: false
			},

			project: {
				type: Object,
				default() {
					return {};
				}
			},

			languageCode: {
				type: String,
				default: ''
			},

			language: {
				type: String,
				default: ''
			},

			posterMode: {
				type: Boolean,
				default: false
			},

			downloadable: {
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				contentCSS: {
					width: '80vw',
					height: '45vw' /* 80/45 = 1.778 */,
					maxHeight: '80vh',
					maxWidth: '142.22vh' /* 16/9 * 80 = 142.22 */,
					backgroundColor: 'rgba(255, 255, 255, 0)',
					borderRadius: '6px'
				},

				// valid: false,
				// snackbar: false,
				// snackbar_text: 'Test',
				// snackbar_color: 'info',
				player: '',
				// url: 'https://someurl.com',
				volume: 1,
				// themeColor: '255, 153, 0',
				options: {
					controls: true,
					autoplay: false,
					preload: 'auto',
					fluid: true,
					html5: {
						nativeTextTracks: false
					},

					allowFullScreen: true,
					poster: null,
					plugins: {
						videoJsResolutionSwitcher: {
							default: '720',
							dynamicLabel: true
						},

						hotkeys: {
							alwaysCaptureHotkeys: true
						}
					}
				},

				textTrackSettings: {
					backgroundOpacity: '0',
					edgeStyle: 'dropshadow',
					color: '#FFF',
					backgroundColor: '#FFF',
					textOpacity: '1',
					windowOpacity: '0',
					fontFamily: 'default',
					windowColor: '#000',
					fontPercent: 1
				}
			};
		},

		computed: {
			videoPlayerModal: {
				get: function () {
					return this.showVideoPlayerModal;
				},

				set: function (newValue) {
					this.$emit('close');
				}
			},

			projectLoadStatus() {
				return this.$store.getters['projects/getStatus']('single');
			},

			videoURL() {
				// console.log('this.$props.languageCode', this.$props.languageCode);
				if (!this.$props.project.hash_id) {
					return 'temp/video/video_1080.mp4';
				} else {
					return '/storage/projects/data/' + this.$props.project.hash_id + '/' + this.$props.languageCode + '/video.mp4';
				}
			},

			posterURL() {
				// console.log('posterURL');

				if (!this.project.poster) return '';

				if (!this.$props.project.hash_id) {
					// console.log('standard');
					return 'temp/video/poster.jpg';
				} else {
					// console.log('special');
					return '/storage/projects/data/' + this.$props.project.hash_id + '/poster.jpg';
				}
			},

			videoFileName() {
				// console.log('this.$props.project', this.$props.project);

				var projectName = this.$props.project.title.trim().toLowerCase().replace(/ /g, '_');
				var customerName = this.$props.project.customer.name.trim().toLowerCase().replace(/ /g, '_');
				var languageCode = this.$props.languageCode.trim().toLowerCase().replace(/ /g, '_');
				var releaseYear = this.$props.project.release_date.substring(0, 4);
				var fileName = customerName + '-' + projectName + '-' + languageCode + '-' + releaseYear;
				fileName = fileName.replace(/[^a-zA-Z0-9_-]/g, '');
				return fileName + '.mp4';
			}
		},

		watch: {
			projectLoadStatus: function (status) {
				// this.setSnackbar(status, 'Project data');
				var This = this;
				if (this.projectLoadStatus === 2) {
					this.$nextTick().then(function () {
						window.playerEvents = This;
						This.playerInitialize();
						// this.playerSetSrc(this.url);
						This.playerSetupEvents();
						// This.playerSetup();
					});
				}
			},

			showVideoPlayerModal: function (status) {
				// console.log('showVideoPlayerModal');
				var This = this;
				// var videoURL = this.videoURL;
				if (status === true) {
					this.$nextTick().then(function () {
						if ($('#myPlayer').length === 0) {
							// console.log(This.videoURL);
							$('#videoContainer').append('<video id="myPlayer" poster="' + This.posterURL + '" class="video-js vjs-16-9 vjs-default-skin vjs-big-play-centered" style="transform:translate3d(0,0,0);"><source src="' + This.videoURL + '" type="video/mp4" label="1080p"></video>');
						}
						This.playerInitialize();
						This.playerSetupEvents();
					});
				} else {
					// console.log('Video Player Modal hidden. Kill the video player!');
					this.playerDispose();
				}
			}
		},

		beforeUnmount() {
			// console.log('myPlayers found: ' + $('#myPlayer').length);
			this.playerDispose();
		},

		created() {
			// console.log('Video player modal created.');
			// this.$store.dispatch('projects/loadSingle', { id: this.$refs.projectID });
		},

		methods: {
			setPosterImage() {
				// console.log('Set poster image!');
				// console.log('this: ', this);
				// console.log('this.language: ', this.language);
				// console.log('this.$props.project.languages: ', this.$props.project.languages);
				var video = document.getElementById('myPlayer_html5_api');
				var canvas = document.createElement('canvas');
				canvas.width = 1920;
				canvas.height = 1080;
				var ctx = canvas.getContext('2d');
				ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
				var dataURI = canvas.toDataURL('image/jpeg');
				var blob = this.dataURLtoBlob(dataURI);
				this.$store
					.dispatch('uploadFiles/uploadPoster', {
						uploadURL: 'files/upload-file',
						file: blob,
						lang_id: this.$props.project.languages[0].id,
						lang_code: this.languageCode,
						// index: this.language_id,
						// upload_url: this.post_url,
						type_id: 2,
						project_hash_id: this.$props.project.hash_id,
						project_id: this.$props.project.id
					})
					.then(response => {
						var object = 'project';
						if (parseInt(response.status) === 200) {
							this.$ToastSwal.fire('OK!', 'The ' + object + ' has been updated.', 'success').then(() => {
								this.$store.dispatch('projects/loadSingle', { id: this.$route.params.id });
							});
						} else {
							this.$ToastSwal.fire('Error!', 'Something went wrong: ' + response.statusText + ' (' + response.status + ')', 'error').then(() => {
								this.$store.dispatch('projects/loadSingle', { id: this.$route.params.id });
							});
						}
					});
			},

			downloadVideo(filename) {
				// console.log(filename);
				var link = document.createElement('a');
				if (typeof link.download === 'string') {
					document.body.appendChild(link); // Firefox requires the link to be in the body
					link.download = filename;
					link.href = this.videoURL;
					link.click();
					document.body.removeChild(link); // remove the link when done
				} else {
					location.replace(this.videoURL);
				}
			},

			// onStartedDownload(id) {
			// 	console.log(`Started downloading: ${id}`);
			// },

			// onFailedDownload(error) {
			// 	console.log(`Download failed: ${error}`);
			// },

			dataURLtoBlob(dataurl) {
				var arr = dataurl.split(','),
					mime = arr[0].match(/:(.*?);/)[1],
					base64String = atob(arr[1]),
					n = base64String.length,
					u8arr = new Uint8Array(n);
				while (n--) {
					u8arr[n] = base64String.charCodeAt(n);
				}
				return new Blob([u8arr], { type: mime });
			},

			playerInitialize() {
				if ($('#myPlayer').length > 0) {
					this.player = videojs('myPlayer', this.options);
					this.player.textTrackSettings.setValues(this.textTrackSettings);
				}
				// else {
				// 	console.log('Player not there.');
				// }
			},

			playerDispose() {
				if (videojs.getPlayer('myPlayer') !== undefined) {
					this.player.dispose();
				}
			},

			// playerPlay() {
			// 	this.player.play();
			// },

			// playerPause() {
			// 	this.player.pause();
			// },

			// playerSetSrc(url) {
			// 	this.player.src(url);
			// },

			// playerSetVolume(float) {
			// 	this.player.volume(float);
			// },

			// playerSetPoster(url) {
			// 	this.player.poster(url);
			// },

			// playerSetTime(time) {
			// 	this.player.currentTime(time);
			// },

			playerEventEnded() {
				// console.log('ended');
			},

			playerEventUserActive() {
				// console.log('userActive');
				$('#video-title').removeClass('video-user-inactive');
			},

			playerEventUserInactive() {
				// console.log('userInactive');
				$('#video-title').addClass('video-user-inactive');
			},

			playerEventVolume() {
				this.volume = this.player.volume();
			},

			playerEventError() {
				console.log(this.playerGetError());
			},

			playerEventPause() {
				// console.log('paused');
				$('#video-title').removeClass('video-playing');
			},

			playerEventPlay() {
				// console.log('play');
				$('#video-title').addClass('video-playing');
			},

			// playerGetPaused() {
			// 	return this.player.paused();
			// },

			// playerGetTime() {
			// 	return this.player.currentTime();
			// },

			playerGetError() {
				return this.player.error().message;
			},

			// playerSetup() {
			// 	$('.video-js .vjs-control-bar').css('background-color', 'rgba(' + this.themeColor + ', 1)');
			// 	$('.video-js .vjs-big-play-button').css('background-color', 'rgba(' + this.themeColor + ', 0.7)');
			// 	$('.vjs-big-play-button').focus(function () {
			// 		$('.vjs-big-play-button').css('background-color', 'rgba(' + this.themeColor + ', 0.5)');
			// 	});
			// 	$('.video-js').hover(
			// 		function () {
			// 			$('.vjs-big-play-button').css('background-color', 'rgba(' + this.themeColor + ', 0.5)');
			// 		},
			// 		function () {
			// 			$('.vjs-big-play-button').css('background-color', 'rgba(' + this.themeColor + ', 0.7)');
			// 		}
			// 	);
			// },

			playerSetupEvents() {
				if ($('#myPlayer').length > 0) {
					window.playerEvents = this;
					const This = this;
					this.player.on('ended', function () {
						This.playerEventEnded();
					});
					this.player.on('volumechange', function () {
						This.playerEventVolume();
					});
					this.player.on('error', function () {
						This.playerEventError();
					});
					this.player.on('pause', function () {
						This.playerEventPause();
					});
					this.player.on('play', function () {
						This.playerEventPlay();
					});
					this.player.on('useractive', function () {
						This.playerEventUserActive();
					});
					this.player.on('userinactive', function () {
						This.playerEventUserInactive();
					});
				}
			}
		}
	};
</script>

<style lang="scss" scoped>
	/* ########## VideoPlayerModal.vue ########## */
	.video-title {
		position: absolute;
		z-index: 1;
		width: 100%;
		height: 98px;
		padding: 12px;
		padding-bottom: 56px;
		background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAADGCAYAAAAT+OqFAAAAdklEQVQoz42QQQ7AIAgEF/T/D+kbq/RWAlnQyyazA4aoAB4FsBSA/bFjuF1EOL7VbrIrBuusmrt4ZZORfb6ehbWdnRHEIiITaEUKa5EJqUakRSaEYBJSCY2dEstQY7AuxahwXFrvZmWl2rh4JZ07z9dLtesfNj5q0FU3A5ObbwAAAABJRU5ErkJggg==');
		background-position: top;
		background-repeat: repeat-x;
		color: #eee;
		pointer-events: none;
		text-shadow: 0 0 2px rgb(0 0 0 / 0.5);
		transition: opacity 0.25s cubic-bezier(0, 0, 0.2, 1);
	}

	/* .vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar { */
	.video-title.video-playing.video-user-inactive {
		opacity: 0;
		transition: visibility 1s, opacity 1s;
		visibility: visible;
	}

	.vjs-poster {
		border-right: none;
		border-left: none;
		background-color: rgb(255 255 255 / 0);
	}

	.ytp-gradient-bottom {
		z-index: 22;
		bottom: 0;
		height: 49px;
		padding-top: 49px;
		background-position: bottom;
	}

	.ytp-gradient-top,
	.ytp-gradient-bottom {
		position: absolute;
		width: 100%;
		background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAADGCAYAAAAT+OqFAAAAdklEQVQoz42QQQ7AIAgEF/T/D+kbq/RWAlnQyyazA4aoAB4FsBSA/bFjuF1EOL7VbrIrBuusmrt4ZZORfb6ehbWdnRHEIiITaEUKa5EJqUakRSaEYBJSCY2dEstQY7AuxahwXFrvZmWl2rh4JZ07z9dLtesfNj5q0FU3A5ObbwAAAABJRU5ErkJggg==');
		background-repeat: repeat-x;
		pointer-events: none;
		transition: opacity 0.25s cubic-bezier(0, 0, 0.2, 1);
	}

	.video-js .vjs-progress-control .vjs-progress-holder {
		margin: 1.35em 0.45em;
	}

	.video-js .vjs-control-bar {
		bottom: 0;
		height: 98px;
		padding-top: 56px;
		background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAADGCAYAAAAT+OqFAAAAdklEQVQoz42QQQ7AIAgEF/T/D+kbq/RWAlnQyyazA4aoAB4FsBSA/bFjuF1EOL7VbrIrBuusmrt4ZZORfb6ehbWdnRHEIiITaEUKa5EJqUakRSaEYBJSCY2dEstQY7AuxahwXFrvZmWl2rh4JZ07z9dLtesfNj5q0FU3A5ObbwAAAABJRU5ErkJggg==');
		background-position: bottom;
		background-repeat: repeat-x;
		color: #eee;
		text-shadow: 0 0 2px rgb(0 0 0 / 0.5);
		transition: opacity 0.25s cubic-bezier(0, 0, 0.2, 1);
	}

	.video-js button {
		text-shadow: 0 0 2px rgb(0 0 0 / 0.5);
	}

	.video-js.vjs-default-skin.vjs-paused .vjs-big-play-button {
		text-shadow: none;
	}

	.video-js .vjs-play-progress::before,
	.video-js .vjs-volume-level::before,
	.vjs-icon-circle::before {
		top: -0.3em;
	}

	.vjs-volume-panel.vjs-control.vjs-volume-panel-horizontal {
		align-items: flex-start;
	}

	.vjs-progress-control.vjs-control {
		align-items: flex-start;
	}

	.poster-btn {
		position: absolute;
		top: 16px;
		right: 16px;
		margin: 0;
	}
</style>
